import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserDetail } from '@/services/userService';
import { QUERY_KEYS } from '@/shared/constant/queryKeys';
import { CACHE_TIMES } from '@/shared/config/reactQuery';

const useUser = () => {
  const queryClient = useQueryClient();

  const {
    data: userDetail,
    isLoading: isUserLoading,
    error: userError,
    refetch: refetchUser,
  } = useQuery({
    queryKey: QUERY_KEYS.USER_DETAIL,
    queryFn: getUserDetail,
    staleTime: CACHE_TIMES.MEDIUM,
    gcTime: CACHE_TIMES.LONG,
    retry: 1,
    refetchOnWindowFocus: false,
  });

  const invalidateUser = () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.USER_DETAIL,
    });
  };

  const clearUserCache = () => {
    queryClient.removeQueries({
      queryKey: QUERY_KEYS.USER_DETAIL,
    });
  };

  return {
    userDetail: userDetail?.data || null,
    isUserLoading,
    userError,
    refetchUser,
    invalidateUser,
    clearUserCache,
  };
};

export default useUser;
